import * as type from './actionTypesSagas';

export const loadRates = (page, isBibRates = false) => ({
  type: type.LOAD_RATES,
  page,
  isBibRates,
});

export const loadAllRates = () => ({
  type: type.LOAD_ALL_RATES,
});

export const loadQuals = (page) => ({
  type: type.LOAD_QUALS,
  page,
});

export const createRate = (fields) => ({
  type: type.CREATE_RATE,
  fields,
});

export const updateSP = (fields) => ({
  type: type.UPDATE_SP,
  fields,
});

export const deleteSP = (sp) => ({
  type: type.DELETE_SP,
  sp,
});
